import React from "react";
import CourseLockedBottomSheet from "../CourseLockedBottomSheet/CourseLockedBottomSheet";
import * as actionCreator from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { getAwsAssets } from "@src/utils";
import { useTranslation } from "react-i18next";
import { initialisePaymentService } from "@src/PaymentService";
import { getLockedContentText } from "@src/utils";
import { safeJsonParse } from "@src/utils/safeJsonParse";
import styles from "./TestIsLockedBottomSheet.module.scss";
import { enrollOnFreeCourse } from "@src/PaymentService/enrollForFreeCourse";
const TestIsLockedBottomSheet = () => {
  const { t } = useTranslation();
  const state = useSelector(
    (state) => state?.bottomSheetReducer?.showTestIsLockedBottomSheet
  );

  const purchaseViaWhatsappV2 = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.purchaseViaWhatsappV2
  );

  const purchaseViaWhatsapp = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.purchaseViaWhatsapp
  );
  
   const isIdfysVerificationRequired = useSelector(
      (state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.verificationDetails?.prePurchase?.isVerificationRequired
    ) || false;

  const dispatch = useDispatch();
  const item = safeJsonParse(localStorage.getItem("currentItem"), {
    source: "TestIsLockedBottomSheet [localStorage.currentItem]",
    fallback: {},
  });
  let scheduledFromDateText = item?.scheduledFromDateText;
  let scheduledToDateText = item?.scheduledToDateText;
  let isPurchased = item?.isPurchased;
  let isScheduled = item?.isScheduled;
  let isLocked = item?.isLocked;
  // let showBtn = isScheduled || (!isPurchased && isLocked) ? 1 : 0;
  let showBtn = isPurchased ? 0 : isLocked;
  const isFreeCourse = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.isFreeCourse
  ) || 0;

  let customClasses = {
    btnText: '',
    viewAllSubText: '',
    parentContainer: ''
  };

  if(isFreeCourse){
    customClasses = {
      btnText: styles.FreeCourse__btnText,
      viewAllSubText: styles.FreeCourse__backBtn,
      parentContainer: styles.FreeCourse__wrapper
    };
  }
  return (
    <CourseLockedBottomSheet
      mainText={t(
        "components.bottomSheets.components.testIsLockedBottomSheet.testIsLocked",
        "Your Content is Locked"
      )}
      subText={getLockedContentText(
        scheduledFromDateText,
        scheduledToDateText,
        isPurchased,
        isScheduled,
        isLocked
      )}
      btnText={
        isFreeCourse
          ? "Get this course for free"
          : purchaseViaWhatsapp || purchaseViaWhatsappV2 === 1
          ? "I'm interested"
          : t(
              "components.bottomSheets.components.testIsLockedBottomSheet.buyNow",
              "Buy now"
            )
      }
      btnAction={() => {
        dispatch(actionCreator.showTestIsLockedBottomSheetAction(false));
        if (isFreeCourse) {
          enrollOnFreeCourse();
        } else if (isIdfysVerificationRequired) {
          dispatch(actionCreator.idfysContentLockAction(true));
        } else {
          initialisePaymentService();
        }
      }}
      viewAllSubText={
        showBtn
          ? t(
              "components.bottomSheets.components.contentLockedBottomSheet.goBackInstead",
              "Go back instead"
            )
          : t(
              "components.bottomSheets.components.contentLockedBottomSheet.goBack",
              "Go back"
            )
      }
      state={state}
      dispatcher={() =>
        dispatch(actionCreator.showTestIsLockedBottomSheetAction(false))
      }
      showBtn={showBtn}
      isCloseButtonVisible={!isFreeCourse}
      customClasses={customClasses}
      iconColor={isFreeCourse ? "#5A5CD4" : ""}
    />
  );
};

export default TestIsLockedBottomSheet;
